import './Subiecte.css';

export default function Subiecte2024() {
    return (
        <div className="container my-4">
            <h2 className="fw-bold mb-4 subjectTitle">{'<'}Subiecte 2024{'/>'}</h2>
            <div className="mb-4">
                <h5>1. <strong>August</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2024/SubiectAugust2024MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2024/SubiectAugust2024MIPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2024/BaremAugust2024MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2024/SubiectAugust2024SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a></li>
                            <li><a href="/subiecte/2024/BaremAugust2024SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div><div className="mb-4">
                <h5>2. <strong>Iunie</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2024/SubiectIunie2024MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2024/SubiectIunie2024MIPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2024/BaremIunie2024MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2024/SubiectIunie2024SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2024/SubiectIunie2024SNPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2024/BaremIunie2024SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div><div className="mb-4">
                <h5>3. <strong>Sesiunea Specială</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2024/SubiectSpeciala2024MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a></li>
                            <li><a href="/subiecte/2024/BaremSpeciala2024MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2024/SubiectSpeciala2024SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a></li>
                            <li><a href="/subiecte/2024/BaremSpeciala2024SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div><div className="mb-4">
                <h5>4. <strong>Simulare</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2024/SubiectSimulare2024MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2024/SubiectSimulare2024MIPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2024/BaremSimulare2024MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2024/SubiectSimulare2024SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2024/SubiectSimulare2024SNPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2024/BaremSimulare2024SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div><div className="mb-4">
                <h5>5. <strong>Model</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2024/SubiectModel2024MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2024/SubiectModel2024MIPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2024/BaremModel2024MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2024/SubiectModel2024SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2024/SubiectModel2024SNPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2024/BaremModel2024SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    );
}